import { toast } from 'react-toastify';

export function generateStrongPassword(length = 8) {
	const uppercase = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
	const lowercase = 'abcdefghijklmnopqrstuvwxyz';
	const numbers = '0123456789';
	const special = '@$%';

	const allCharacters = uppercase + lowercase + numbers + special;
	let password = '';

	password += uppercase[Math.floor(Math.random() * uppercase.length)];
	password += lowercase[Math.floor(Math.random() * lowercase.length)];
	password += numbers[Math.floor(Math.random() * numbers.length)];
	password += special[Math.floor(Math.random() * special.length)];

	for (let i = password.length; i < length; i++) {
		password += allCharacters[Math.floor(Math.random() * allCharacters.length)];
	}

	password = password
		.split('')
		.sort(() => Math.random() - 0.5)
		.join('');

	return password;
}

export function copyToClipboard(text) {
	navigator.clipboard
		.writeText(text)
		.then(() => {
			toast.success('Password copied to clipboard!');
		})
		.catch((err) => {
			console.error('Could not copy text: ', err);
		});
}
export const encodeEmailToToken = (email) => {
	return btoa(email);
};

export const decodeTokenToEmail = (token) => {
	return atob(token);
};

export const objectCreater = (array) => {
	return array?.map((array) => ({
		value: parseInt(array?.id),
		label: array?.name?.charAt(0) + array.name.slice(1).toLowerCase().replace(/&/, 'and'),
	}));
};
export const newObjectCreater = (array) => {
	return array?.map((array) => ({
		key: parseInt(array?.id),
		value: array?.name?.charAt(0) + array.name.slice(1).toLowerCase().replace(/&/, 'and'),
	}));
};

export const formatErrors = (errorArray) => {
	console.log(errorArray);
	if (typeof errorArray === 'object' && Object.keys(errorArray).length > 0) {
		return errorArray?.reduce((acc, error) => {
			let field = error.path[0];
			let message = error.message;

			const formattedField = field
				.split('_')
				.map((word) => word.charAt(0).toUpperCase() + word.slice(1))
				.join(' ');

			acc[field] = `${message}`;
			return acc;
		}, {});
	}
};
export const formatError = (errorArray) => {
	if (!Array.isArray(errorArray)) {
		console.error('formatErrors expects an array:', errorArray);
		return {};
	}

	return errorArray.reduce((acc, error) => {
		const field = error?.path?.[0] || 'general';
		const message = error?.message || 'Invalid value';

		acc[field] = message;
		return acc;
	}, {});
};
export const hasPermission = (key, permission = []) => {
	// const selectedPermissionKey = permission.map((item) => item.permission.key);
	return permission.includes(key);
};
